import { UndoRedoStep } from "Interfaces";
import React from "react";
import create from "zustand";

interface Store {
    isViewerMode: boolean,
    isEditorMode: boolean,
    isMobile: boolean,
    dialogs: ({ id: string, dialog: React.ReactElement })[],
    addDialog: (id: string, dialog: React.ReactElement) => void,
    removeDialog: (id: string) => void,
    selectedGroupId: number | null,
    selectedAttributeId: number | null,
    selectedStepId: number | null,
    setSelectedGroupId: (group: number | null) => void,
    setSelectedAttributeId: (attribute: number | null) => void,
    setSelectedStepId: (step: number | null) => void,
    isLoading: boolean,
    setIsLoading: (isLoading: boolean) => void,
    isQuoteLoading: boolean,
    setIsQuoteLoading: (isQuoteLoading: boolean) => void,
    priceFormatter: Intl.NumberFormat,
    setPriceFormatter: (priceFormatter: Intl.NumberFormat) => void
    undoStack: (UndoRedoStep[] | any[any]),
    setUndoStack: (callback: (undoStack: UndoRedoStep[] | any[any]) => UndoRedoStep[] | any[any]) => void,
    redoStack: (UndoRedoStep[] | any[any]),
    setRedoStack: (callback: (redoStack: UndoRedoStep[] | any[any]) => UndoRedoStep[] | any[any]) => void,
    isUndo: boolean,
    setIsUndo: (isUndo: boolean) => void,
    isRedo: boolean,
    setIsRedo: (isRedo: boolean) => void,
    previousCustomizeOptionId: number,
    setPreviousCustomizeOptionId: (previousSelectedOptionId: number) => void
}

const useStore = create<Store>((set) => ({
    isViewerMode: new URLSearchParams(window.location.href).get('viewerMode') ? true : false,
    isEditorMode: new URLSearchParams(window.location.href).get('isDraftEditor') ? true : false,
    isMobile: window.innerWidth < 768,
    dialogs: [],
    addDialog: (id: string, dialog: React.ReactElement) => {
        set(state => ({
            dialogs: [...state.dialogs, { id, dialog }],
        }));
    },
    removeDialog: (id: string) => {
        set(state => ({
            dialogs: state.dialogs.filter(dialog => dialog.id !== id),
        }));
    },

    isLoading: false,
    setIsLoading: (isLoading: boolean) => {
        set({
            isLoading,
        });
    },
    isQuoteLoading: false,
    setIsQuoteLoading: (isQuoteLoading: boolean) => {
        set({
            isQuoteLoading,
        });
    },
    selectedGroupId: null,
    setSelectedGroupId: (groupId) => set({
        selectedGroupId: groupId
    }),
    selectedAttributeId: null,
    setSelectedAttributeId: (attributeId) => set({
        selectedAttributeId: attributeId
    }),
    selectedStepId: null,
    setSelectedStepId: (stepId) => set({
        selectedStepId: stepId
    }),
    priceFormatter: new Intl.NumberFormat('it-IT', {
        style: "currency",
        currency: 'EUR'
    }),
    setPriceFormatter: (priceFormatter: Intl.NumberFormat) => {
        set({
            priceFormatter
        })
    },
    undoStack: [],
    setUndoStack: (callback) => {
        set(prev => ({
            undoStack: callback(prev.undoStack)
        }))
    },
    redoStack: [],
    setRedoStack: (callback) => {
        set(prev => ({
            redoStack: callback(prev.redoStack)
        }))
    },
    isUndo: false,
    setIsUndo: (isUndo: boolean) => {
        set({
            isUndo,
        });
    },
    isRedo: false,
    setIsRedo: (isRedo: boolean) => {
        set({
            isRedo,
        });
    },
    previousCustomizeOptionId: 526068,
    setPreviousCustomizeOptionId(previousCustomizeOptionId: number) {
        set({
            previousCustomizeOptionId
        })
    },
}));

export default useStore;